export const AYA_STREAM_PROTOCOL = 'aya.stream.v2';

export type AyaStreamProtocol = typeof AYA_STREAM_PROTOCOL;

/* eslint-disable @typescript-eslint/naming-convention */
export interface IStreamMessageRequestRaw {
  message?: string | null;
  client_message_id?: string;
  knowledge_document_id?: string;
  quick_action_id?: string;
  attachment_ids?: string[];
  information_ids?: string[];
  stream_protocol: AyaStreamProtocol;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface IStreamMessageRequest {
  message?: string | null;
  clientMessageId?: string;
  knowledgeDocumentId?: string;
  quickActionId?: string;
  attachmentIds?: string[];
  informationIds?: string[];
}

export const toStreamMessageRequest = (
  request: IStreamMessageRequest
): IStreamMessageRequestRaw => ({
  message: request.message,
  ...(request.clientMessageId && {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    client_message_id: request.clientMessageId
  }),
  ...(request.knowledgeDocumentId && {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    knowledge_document_id: request.knowledgeDocumentId
  }),
  ...(request.quickActionId && {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    quick_action_id: request.quickActionId
  }),
  ...(request.attachmentIds?.length && {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    attachment_ids: request.attachmentIds
  }),
  ...(request.informationIds?.length && {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    information_ids: request.informationIds
  }),
  // eslint-disable-next-line @typescript-eslint/naming-convention
  stream_protocol: AYA_STREAM_PROTOCOL
});
